import React from "react"
import HeaderImage from "../../../assets/images/header.png"

function Header () {
  return (
    <>
      <button onClick={() => document.location.hash="main-content"} class="skip-to-content">Skip to Content</button>
      
      <header>
        <img src={HeaderImage} alt="Least1234" loading="lazy" />
      </header>
    </>
  )
}

export default Header